// extracted by mini-css-extract-plugin
module.exports = {"input":"FileButton_input__1JQwE","label":"FileButton_label__g0JS_","spinner":"FileButton_spinner__1PuFP"};